import { z } from "zod";

/** Inpatient Phase 5 — Operating Theatre: rooms + scheduled surgeries. */

export const surgeryStatusSchema = z.enum([
	"scheduled",
	"in_progress",
	"completed",
	"cancelled",
]);
export type SurgeryStatus = z.infer<typeof surgeryStatusSchema>;

// ===== Operating room =====
export const operatingRoomApiSchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	name: z.string(),
	notes: z.string().nullable(),
	is_active: z.boolean(),
	created_at: z.string().datetime(),
});
export type OperatingRoomApi = z.infer<typeof operatingRoomApiSchema>;

export const createOperatingRoomInputSchema = z.object({
	name: z.string().min(1).max(120),
	notes: z.string().max(1000).nullable().optional(),
});
export type CreateOperatingRoomInput = z.infer<
	typeof createOperatingRoomInputSchema
>;

// ===== Surgery (case) =====
export const surgeryApiSchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	patient_id: z.string().uuid(),
	admission_id: z.string().uuid().nullable(),
	operating_room_id: z.string().uuid().nullable(),
	procedure: z.string(),
	surgeon_member_id: z.string().uuid().nullable(),
	anesthetist_member_id: z.string().uuid().nullable(),
	scheduled_start: z.string().datetime(),
	scheduled_end: z.string().datetime(),
	status: z.string(),
	actual_start: z.string().datetime().nullable(),
	actual_end: z.string().datetime().nullable(),
	pre_op_notes: z.string().nullable(),
	op_notes: z.string().nullable(),
	created_at: z.string().datetime(),
	// Computed joins for the schedule board.
	patient_name: z.string().optional(),
	room_name: z.string().nullable().optional(),
});
export type SurgeryApi = z.infer<typeof surgeryApiSchema>;

export const scheduleSurgeryInputSchema = z.object({
	patient_id: z.string().uuid(),
	admission_id: z.string().uuid().nullable().optional(),
	operating_room_id: z.string().uuid().nullable().optional(),
	procedure: z.string().min(1).max(500),
	surgeon_member_id: z.string().uuid().nullable().optional(),
	anesthetist_member_id: z.string().uuid().nullable().optional(),
	scheduled_start: z.string().datetime(),
	scheduled_end: z.string().datetime(),
	pre_op_notes: z.string().max(2000).nullable().optional(),
});
export type ScheduleSurgeryInput = z.infer<typeof scheduleSurgeryInputSchema>;

export const updateSurgeryStatusInputSchema = z.object({
	status: z.enum(["in_progress", "completed", "cancelled"]),
	op_notes: z.string().max(4000).nullable().optional(),
});
export type UpdateSurgeryStatusInput = z.infer<
	typeof updateSurgeryStatusInputSchema
>;
